import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=c1c0d32c&scoped=true"
import script from "./UI.vue?vue&type=script&lang=ts"
export * from "./UI.vue?vue&type=script&lang=ts"
import style0 from "./UI.vue?vue&type=style&index=0&id=c1c0d32c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c0d32c",
  null
  
)

export default component.exports